module.exports = __webpack_public_path__ + "img/banner-2-1@1x.b787d747.jpg";